var getPrefixAndSuffix = function (actionTypeString) {
    var actionAsArray = actionTypeString.split('/');
    var suffix = actionAsArray.pop();
    var prefix = actionAsArray.join('/');
    return [prefix, suffix];
};
var isAsyncAction = function (action) {
    return action.type.endsWith('/rejected') ||
        action.type.endsWith('/pending') ||
        action.type.endsWith('/fulfilled');
};
export var isAnyAsyncActionOf = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return function (currentAction) {
        return isAsyncAction(currentAction) &&
            actions.includes(getPrefixAndSuffix(currentAction.type)[0]);
    };
};
export var handleAsyncActions = function (state, action) {
    var actionAndStatus = getPrefixAndSuffix(action.type);
    state.actionStatuses[actionAndStatus[0]] = {
        status: actionAndStatus[1].toUpperCase(),
        error: action.type.endsWith('/rejected') ? action.payload : {},
    };
};
